var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E68F7B",
    d: "m10 0 6.08 10.046-6.057-2.589L10 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8EC7C",
    d: "M3.938 10.046 10 0l.023 7.457-6.085 2.59Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6EB87D",
    d: "m10 13.75-6.063-3.704 6.086-2.589L10 13.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#946BA7",
    d: "m16.08 10.046-6.057-2.589L10 13.75l6.08-3.704Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#697CB9",
    d: "m10 15.026 6.08-3.604L10 19.988v-4.962Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4FADD0",
    d: "m10 15.026-6.063-3.604L10 19.988v-4.962Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.57de6d8016e5650234d47d26fb71779d.svg";
export { ForwardRef as ReactComponent };